import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import config from '../../../../tailwind.config'

const MediaQuery = ({ breakpoint, type = 'min', children }) => {
  const [visible, setVisible] = useState(false)
  let mq = null

  useEffect(() => {
    if (breakpoint) {
      registerMediaQuery()
      toggleVisibility(mq)
    }

    return () => {
      if (breakpoint && mq) {
        mq.removeListener(toggleVisibility);
      }
    }
  }, [breakpoint])

  const registerMediaQuery = () => {
    const size = getBreakpoint()
    mq = window.matchMedia(`(${type}-width: ${size})`)
    mq.addListener(toggleVisibility)
  }

  const getBreakpoint = () => {
    const breakpoints = config.theme.screens
    const size = breakpoints[breakpoint]

    if (type === 'max') {
      const value = parseFloat(size)
      return `${Math.abs(value - 0.0625)}em`
    }

    return size
  }

  const toggleVisibility = (e) => {
    setVisible(e.matches)
  }

  return (
    <>
      {visible && children}
    </>
  )
}

MediaQuery.propTypes = {
  breakpoint: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.any,
}

export default MediaQuery
